import {FC} from 'react'
import {useLang} from './Metronici18n'
import {IntlProvider} from 'react-intl'
import '@formatjs/intl-relativetimeformat/polyfill'
import '@formatjs/intl-relativetimeformat/locale-data/en'
import '@formatjs/intl-relativetimeformat/locale-data/de'
import '@formatjs/intl-relativetimeformat/locale-data/es'
import '@formatjs/intl-relativetimeformat/locale-data/fr'
import '@formatjs/intl-relativetimeformat/locale-data/ja'
import '@formatjs/intl-relativetimeformat/locale-data/zh'
import '@formatjs/intl-relativetimeformat/locale-data/ru'

import enMessages from './messages/en.json'
import ruMessages from './messages/ru.json'
import kzMessages from './messages/kz.json'

const allMessages = {
  en: enMessages,
  ru: ruMessages,
  kk: kzMessages,
}

const I18nProvider: FC = ({children}) => {
  const locale = useLang()
  const messages = allMessages[locale as keyof typeof allMessages]
  return (
    <IntlProvider locale={locale ? locale : "ru"} messages={messages}>
      {children}
    </IntlProvider>
  )
}

export {I18nProvider}
